module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "main",
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEmpty),
      expression: "isEmpty"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-no-matching-img",
    attrs: {
      "src": require("../../../static/img/icon_no_matching_result.svg")
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box box-warning"
    }, [_c('div', {
      staticClass: "logs-header"
    }, [_c('h1', {
      staticClass: "logs-date"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('h2', {
      staticClass: "logs-version"
    }, [_vm._v("\n            (\n            "), _c('strong', [_vm._v(_vm._s(item.platform))]), _vm._v("\n            " + _vm._s(item.versionname) + ")\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "row logs-body data_aggregation_table_margin"
    }, [_c('table', {
      staticClass: "logs-table"
    }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(item.left.platformName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(item.right.platformName))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "device-information-table-title table-width-quarter data_aggregation_title_color"
    }, [_c('pre', {
      staticClass: "logs-content",
      attrs: {
        "contenteditable": ""
      },
      on: {
        "focusout": function($event) {
          _vm.focusout(item.left, $event, 'developlog')
        }
      }
    }, [_vm._v(_vm._s(item.left.developlog))])]), _vm._v(" "), _c('td', {
      staticClass: "device-information-table-title table-width-quarter data_aggregation_title_color"
    }, [_c('pre', {
      staticClass: "logs-content",
      attrs: {
        "contenteditable": ""
      },
      on: {
        "focusout": function($event) {
          _vm.focusout(item.right, $event, 'developlog')
        }
      }
    }, [_vm._v(_vm._s(item.right.developlog))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "device-information-table-content table-width-quarter data_aggregation_title_color"
    }, [_c('pre', {
      staticClass: "logs-content logs-note",
      attrs: {
        "contenteditable": ""
      },
      on: {
        "focusout": function($event) {
          _vm.focusout(item.left, $event, 'releaselog')
        }
      }
    }, [_vm._v(_vm._s(item.left.releaselog))])]), _vm._v(" "), _c('td', {
      staticClass: "device-information-table-content table-width-quarter data_aggregation_title_color"
    }, [_c('pre', {
      staticClass: "logs-content logs-note",
      attrs: {
        "contenteditable": ""
      },
      on: {
        "focusout": function($event) {
          _vm.focusout(item.right, $event, 'releaselog')
        }
      }
    }, [_vm._v(_vm._s(item.right.releaselog))])])])])])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("No update logs found.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c6b36f4a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6b36f4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/UpdateLogs.vue
// module id = 495
// module chunks = 1